import { Component, Input, OnInit } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
import { createComponentValueAccessor } from '@app/shared/utils';

@Component({
  standalone: false,
  selector: 'ti-tmf-document-selector',
  templateUrl: './tmf-document-selector.component.html',
  styleUrls: ['./tmf-document-selector.component.sass'],
  providers: [createComponentValueAccessor(TmfDocumentSelectorComponent)],
})
export class TmfDocumentSelectorComponent implements OnInit, ControlValueAccessor {
  @Input() isReadOnly: boolean;

  readonly miscStrings = tiStrings.app.misc;

  seed: string;

  private _isLinkedRoomMetadataMode: boolean = false;
  set isLinkedRoomMetadataMode(v: boolean) {
    this._isLinkedRoomMetadataMode = !!v;
    this.onChange(v);
  }
  get isLinkedRoomMetadataMode(): boolean {
    return !!this._isLinkedRoomMetadataMode;
  }

  // #region AccessorProps
  onChange: any = () => {};
  onTouch: any = () => {};
  // #endregion

  constructor() {
    // we need this to prevent bugs if there are few instances of this component are active at the same time (it is possible)
    this.seed = Math.random().toString(36).substr(2, 9);
  }

  ngOnInit() {}

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  writeValue(v: boolean): void {
    this._isLinkedRoomMetadataMode = v;
  }
}
